<template>
  <nav class="bg-white border-b border-gray-200 shadow-sm dark:bg-gray-900 lg:block dark:border-gray-800">
    <div class="mx-auto max-w-screen-lg">
      <div class="flex items-center">
        <ul class="flex flex-col mt-0 w-full text-sm font-medium lg:flex-row">
          <li
            v-for="item in menuItems"
            :key="item.label"
            class="block border-b dark:border-gray-700 lg:inline lg:border-b-0"
          >
            <a
              :aria-current="item.isActive ? 'page' : null"
              :class="item.isActive ? 'border-b-2 text-primary-600 dark:text-primary-500 dark:border-primary-500 border-black font-bold text-black' : 'border-b-2 text-gray-500 border-white dark:border-gray-900 dark:hover:text-gray-500 dark:hover:border-gray-500 hover:border-gray-600'"
              :href="item.path"
              class="block py-3 px-4 dark:text-gray-400 hover:text-primary-600"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';

export default defineComponent({
  name: 'AdministratorNavbar',
  setup() {
    const route = useRoute();

    const menuItems = ref([
      {path: '/administrator/', label: 'Dashboard', isActive: false},
      {path: '/administrator/courses', label: 'Courses', isActive: false},
      {path: '/administrator/users', label: 'Users', isActive: false},
      {path: '/administrator/events', label: 'Events', isActive: false},
      {path: '/administrator/announcements', label: 'Announcements', isActive: false},
      {path: '/administrator/pages', label: 'Pages', isActive: false},
      {path: '/administrator/settings', label: 'Settings', isActive: false},
    ]);

    const updateActiveMenuItem = () => {
      const currentPath = route.path;
      menuItems.value = menuItems.value.map(item => ({
        ...item,
        isActive: item.path === currentPath,
      }));
    };

    onMounted(() => {
      updateActiveMenuItem();
    });

    return {
      menuItems,
    };
  },
});
</script>
